export default {
  // Auth Endpoints
  logEndpoint: '/auth/login',
  logsEndpoint: '/auth/logs',
  loginEndpoint: '/auth/login',
  logoutEndpoint: '/auth/logout',
  registerEndpoint: '/auth/register',
  completeOnboardEndpoint: '/auth/onboard',
  updateUserProfileEndpoint: '/auth/profile',
  confirmPhoneEndpoint: '/auth/confirm-phone',
  confirmTokenValidityEndpoint: '/auth/check',
  confirmEmailEndpoint: '/auth/confirm-email',
  resetPasswordEndpoint: '/auth/reset-password',
  changePasswordEndpoint: '/auth/password/change',
  userNotificationsEndpoint: '/auth/notifications',
  userSupportTicketsEndpoint: '/auth/support-tickets',
  registrationSettingsEndpoint: '/auth/registration/settings',
  requestPasswordResetEndpoint: '/auth/request-password-reset',
  requestPhoneVerificationEndpoint: '/auth/request-phone-verification',
  checkPasswordResetValidityEndpoint: '/auth/check-password-reset-token',
}
